import * as React from "react";
import { useMemo } from "react";
import { RowContainer } from "components/lookup-tables/layout-componets";
import usePluginEntities from "hooks/usePluginEntities";
import Cache from "components/lookup-tables/Cache";
function CacheShow({ cache }) {
  var _a;
  const plugins = usePluginEntities("lookupTableCaches");
  const cachePlugin = useMemo(
    () => plugins.find((p) => {
      var _a2;
      return p.type === ((_a2 = cache == null ? void 0 : cache.config) == null ? void 0 : _a2.type);
    }),
    [(_a = cache == null ? void 0 : cache.config) == null ? void 0 : _a.type, plugins]
  );
  const DocComponent = useMemo(() => cachePlugin == null ? void 0 : cachePlugin.documentationComponent, [cachePlugin]);
  return /* @__PURE__ */ React.createElement(RowContainer, { $gap: "xl", $withDocs: !!DocComponent, $justify: "center" }, /* @__PURE__ */ React.createElement("div", { style: { width: DocComponent ? "50%" : "100%" } }, /* @__PURE__ */ React.createElement(Cache, { cache, noEdit: true })), DocComponent && /* @__PURE__ */ React.createElement("div", { style: { width: "50%" } }, /* @__PURE__ */ React.createElement(DocComponent, { cacheId: cache == null ? void 0 : cache.id })));
}
export default CacheShow;
